export default __webpack_public_path__ + "static/media/22.d7520552.pdf";